module.exports = __webpack_public_path__ + "img/testimonials-2.b56133f4.jpg";